import { ChangeDetectionStrategy, Component, effect, inject, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { GenerationChatComponent } from '../generation-chat/generation-chat.component';
import { GenerationChatService } from '../generation-chat/generation-chat.service';
import { AiAssistantI18nModule } from '../../assets/i18n/ai-assistant-i18n.module';

const AUTOMATION_GENERATION_TYPE = 'automation';

export interface AutomationAssistantBuilderDialogData {
  automationId?: string | null;
}

@Component({
  selector: 'ai-automation-assistant-builder',
  imports: [MatButtonModule, MatIconModule, GenerationChatComponent, AiAssistantI18nModule],
  providers: [GenerationChatService],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './automation-assistant-builder.component.html',
  styleUrl: './automation-assistant-builder.component.scss',
})
export class AutomationAssistantBuilderComponent {
  readonly automationId = input<string | null>(null);

  readonly cancelled = output<void>();

  private readonly chatService = inject(GenerationChatService);
  private readonly dialogRef = inject<MatDialogRef<AutomationAssistantBuilderComponent> | null>(MatDialogRef, {
    optional: true,
  });
  private readonly dialogData = inject<AutomationAssistantBuilderDialogData | null>(MAT_DIALOG_DATA, {
    optional: true,
  });

  constructor() {
    this.chatService.setGenerationType(AUTOMATION_GENERATION_TYPE);

    effect(() => {
      const id = this.automationId() ?? this.dialogData?.automationId ?? null;
      this.chatService.setExtraContextVariables(id ? [{ key: 'AutomationId', value: id }] : []);
    });
  }

  cancel(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
      return;
    }
    this.cancelled.emit();
  }
}
